
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class InstructionPopup extends Vue {
  showInstructions = true;

  texts = this.$t('context.driversPage.pages.interactiveTool.instructionPopup');
  mounted() {
    if (!localStorage.getItem('cwcb-dismiss-slider-notification')) {
      localStorage.setItem('cwcb-dismiss-slider-notification', 'false');
    }

    if (localStorage.getItem('cwcb-dismiss-slider-notification') === 'true') {
      this.showInstructions = false;
    }
  }

  hideCard() {
    this.showInstructions = false;
  }

  get boxValue(): boolean {
    const value = localStorage.getItem('cwcb-dismiss-slider-notification');
    return value === 'true' ? true : false;
  }

  set boxValue(newVal: boolean) {
    if (newVal) {
      localStorage.setItem('cwcb-dismiss-slider-notification', 'true');
    } else {
      localStorage.setItem('cwcb-dismiss-slider-notification', 'false');
    }
  }
}
